import React, { useEffect, useState } from 'react'
import { Row, Col, TagPicker } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputTagGroupForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value || [])
  const placeholder = props.placeholder || schema?.hint || schema?.label

  useEffect(() => {
    setInputValue(props.value || schema?.value || '')
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p>{requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}</p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <TagPicker
                    data={schema.options || []}
                    block
                    value={inputValue || props.value}
                    disabled={disabled || schema.disabled}
                    placeholder={placeholder}
                    onChange={(value) => {
                      if (value?.length == 0) {
                        value = null
                      }
                      props.onChange(value)
                      setInputValue(value)
                      onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
